<h1 mat-dialog-title style="color: #004F70; font-weight: 900; font-size: 2rem;">Grand jeu : Braderie des commerçants</h1>
<div mat-dialog-content>
  <div style="display: flex; flex-wrap: wrap;" [ngStyle]="{ 'flex-direction': (isHandset$ | async) ? 'column': 'row' }">
    <div style="flex: 3;">
      <div>
        <h3 style="font-weight: bold;">Participez à la braderie des commerçants <span style="color:  #004F70">le vendredi 1er et samedi 2 octobre !</span></h3>
        <p>L’association des commerçants et artisans de Levallois, l’ACAL organise le 1er/2 octobre un grand jeu ouvert à toute personne majeure.<br />
        Pour participer, il vous suffit de vous rendre chez vos commerçants le 1er et 2 octobre, d’y effectuer un achat et de déposer votre formulaire de participation dans une urne.</p>

        <p style="font-weight: bold;">Si vous êtes tiré au sort, vous pourrez obtenir un remboursement allant jusqu'à 100€ sur vos achats !</p>

        <h3 style="font-weight: bold;">2 gains possibles</h3>
        <p>50€ / 100€</p>

        <p>L’association des commerçants et artisans de Levallois, l’ACAL <b style="color:  #004F70">offre 25 lots à l’occasion de ce jeu.</b></p>
        <br />
      </div>
      
      <div style="flex: 2; display: flex; justify-content: space-evenly; margin: 1rem 0;" [ngStyle]="{ 'flex-direction': (isHandset$ | async) ? 'column': 'row' }">
        <a mat-stroked-button href="assets/braderie/reglement.pdf" target="_blank" style="margin: 1rem;"><mat-icon style="margin-right: 1rem; color: #004F70;">cloud_download</mat-icon> Règlement du jeu</a>
      </div>
    </div>
    <div style="flex: 1; padding: 10px;">
     <img src="assets/braderie/affiche.jpg" style="max-width: 100%;" />
    </div>
  </div>
</div>